module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_wrap"
  }, [(!_vm.isAgreement) ? _c('el-button', {
    staticClass: "start_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.agreement()
      }
    }
  }, [_vm._v("开始入驻")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "f666 tc"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isAgreement) ? _c('div', [_c('el-checkbox', {
    staticClass: "mt20",
    on: {
      "change": _vm.hangle
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("我同意大V店《供应商入驻协议》")]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.checked ? '/edit_info_basic' : '#'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.checked
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("一.入驻流程")]), _vm._v(" "), _c('p', [_vm._v("入驻申请→初审→编辑线上合同→复审→缴纳保证金→提交纸质材料→开通后台账号；")]), _vm._v(" "), _c('p', [_vm._v("注：每一个环节的状态，系统都会邮件或短信告知商家，商家也可以登入注册账号进行查询。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up_info mt20"
  }, [_c('p', [_vm._v("二.入驻须知")]), _vm._v(" "), _c('p', [_vm._v("(1) 商家入驻的品类如果涉及到多个部门，系统仅允许“先”入驻一个部门负责的品类，待入驻成功后方可入驻其他品类；")]), _vm._v(" "), _c('p', [_vm._v("(2) 商家申请主营品牌有两种方式：第一种，选择大V店品牌库已有的品牌；第二种，手动输入大V店品牌库还未录入的品牌信息。商家需优先采用第一种方式，如果品牌库搜索不到，再采用第二种方式；")]), _vm._v(" "), _c('p', [_vm._v("(3) 非图书品类的每一个品牌均需选择要入驻的品类，未选择入驻的品类，后期创建商品信息则无法创建成功；")]), _vm._v(" "), _c('p', [_vm._v("(4) 入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销；")]), _vm._v(" "), _c('p', [_vm._v("(5) 商家入驻多个品类，只需缴纳一份保证金，保证金取多个品类中最高的。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-364f824c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/matters.vue
// module id = 512
// module chunks = 0